// import * as React from "react";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { TimePicker } from "@mui/x-date-pickers/TimePicker";

// interface EventEHRTimePickerProps {
//   label?: string;
//   ampmFormat?: boolean;
//   name?: string;
//   handleTimeChange?: (e: any) => void;
// }

// export default function EventEHRTimePicker({
//   name = "",
//   label = "Your label here",
//   ampmFormat = false,
//   handleTimeChange,
// }: EventEHRTimePickerProps) {
//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <TimePicker
//         name="name"
//         slotProps={{ textField: { size: "small" } }}
//         label={label}
//         ampm={ampmFormat}
//         onChange={handleTimeChange}
//       />
//     </LocalizationProvider>
//   );
// }

import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker as TimePickerWrapper } from "@mui/x-date-pickers/TimePicker";
import dayjs, { Dayjs } from "dayjs";

interface EventEHRTimePickerProps {
  name?: string;
  label?: string;
  value?: Dayjs | string | null; // Accepts both Dayjs and string for flexibility
  onChangeCb?: (value: Dayjs | null) => void;
  style?: Record<string, string>;
  error?: boolean;
  helperText?: string;
  isStarPresent?: boolean;
  ampmFormat?: boolean;
  defaultValue?: boolean;
  onBlur?: (e: any) => void;
}

export default function EventEHRTimePicker({
  name,
  label = "Select Time",
  value = null,
  onChangeCb = () => {
    /* no-op */
  },
  style = {},
  error = false,
  helperText = "",
  isStarPresent = false,
  ampmFormat = false,
  defaultValue = false,
  onBlur = (e) => {},
}: EventEHRTimePickerProps) {
  // const [placeholder, setPlaceholder] = React.useState("Enter Time"); // Custom placeholder state

  // Ensure the value is a Dayjs object
  const parsedValue = typeof value === "string" ? dayjs(value, "HH:mm") : value;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePickerWrapper
        name={name}
        label={
          <>
            {label}{" "}
            {isStarPresent && <span style={{ color: "#CE0718" }}>*</span>}
          </>
        }
        // value={parsedValue} // Ensure the correct type
        value={defaultValue ? parsedValue : null} // Ensure the correct type
        onChange={onChangeCb}
        ampm={ampmFormat}
        slotProps={{
          textField: {
            size: "small",
            fullWidth: true,
            error: error,
            helperText: helperText,
            onBlur: onBlur,
            // onBlur: (e) => {
            //   setPlaceholder("Enter Time"); // Reset placeholder on blur
            //   onBlur(e);
            // },
            // inputProps: {
            //   placeholder: placeholder,
            //   onFocus: () => setPlaceholder("hh:mm"), // Change placeholder on focus
            // },
          },
        }}
        sx={style}
      />
    </LocalizationProvider>
  );
}
